import React, { useEffect, useState } from 'react'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'

// Member's own unit plan. Read-only: members cannot edit, add or delete anything here.
const SingleUserunitplan = () => {
  const [users, setUsers] = useState([])

  useEffect(() => {
    const load = async () => {
      const token = localStorage.getItem('token')
      try {
        const res = await axios.get(`${config.apiUrl}/flat-details`, {
          headers: { Authorization: token }
        })
        const item = res.data.data
        if (!item) return

        setUsers([{
          id: item.ID,
          username: item.MembersName?.trim() || '',
          RoomNo: `${item.BldgNo || ''} / ${item.FlatNo || ''}`,
          CurrentAreaCASqft: item.CurrentAreaCASqft || '',
          EligibleAreaCAPlus50PercentSqft: item.EligibleAreaCAPlus50PercentSqft || '',
          NearestAreaAsPerPlanSqft: item.NearestAreaAsPerPlanSqft || '',
          FlatSizeOptedAsPerScheme: item.FlatSizeOptedAsPerScheme || 'NA',
          DifferenceInAreaSqft6Minus5: item.DifferenceInAreaSqft6Minus5 || 'NA',
          AdditionalAreaAsPerSchemeI7Minus5: item.AdditionalAreaAsPerSchemeI7Minus5 || 'NA',
          JodiFlat: item.JodiFlat || 'NA',
          ExtraFlatSchemeII: item.ExtraFlatSchemeII || 'NA',
          deletedOn: item.DeletedOn
        }])
      } catch (err) {
        console.error('API ERROR:', err.response || err)
        toast.error('Failed to load users')
      }
    }
    load()
  }, [])

  return (
    <div id="app-Capsule">
      <div className="pt-4">
        <h2 style={{ paddingTop: '2rem', textAlign: 'center' }}>Single Users Unit Plan</h2>
        <div
          className="table-responsive-sm pt-5"
          style={{
            maxHeight: '100vh',
            overflowY: 'auto'
          }}
        >
          <table className="table table-bordered">
            <thead>
              <tr>
                <th className="text-center text-bold fs-6">Sr.No</th>
                <th className="text-center text-bold fs-6">Name</th>
                <th className="text-center fs-6 text-bold">Bldg No./ FlatNo</th>
                <th className="text-center fs-6 text-bold">Current area CA Sqft</th>
                <th className="text-center fs-6 text-bold">Eligible area CA Plus 50 Percent Sqft</th>
                <th className="text-center fs-6 text-bold">Nearest Area As Per Plan Sqft</th>
                <th className="text-center fs-6 text-bold">Flat Size Opted As Per Scheme</th>
                <th className="text-center fs-6 text-bold">Difference In Area Sqft 6 Minus 5</th>
                <th className="text-center fs-6 text-bold">Additional Area As Per Scheme I7 Minus 5</th>
                <th className="text-center fs-6 text-bold">Jodi Flat</th>
                <th className="text-center fs-6 text-bold">Extra Flat Scheme II</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id}
                  className="text-center"
                  style={{ background: user.deletedOn ? 'rgb(220 220 220)' : 'inherit' }}
                >
                  <th scope="row">{index + 1}</th>
                  <td className="text-bold">{user.username}</td>
                  <td className="text-bold">{user.RoomNo}</td>
                  <td className="text-bold">{user.CurrentAreaCASqft}</td>
                  <td className="text-bold">{user.EligibleAreaCAPlus50PercentSqft}</td>
                  <td className="text-bold">{user.NearestAreaAsPerPlanSqft}</td>
                  <td className="text-bold">{user.FlatSizeOptedAsPerScheme}</td>
                  <td className="text-bold">{user.DifferenceInAreaSqft6Minus5}</td>
                  <td className="text-bold">{user.AdditionalAreaAsPerSchemeI7Minus5}</td>
                  <td className="text-bold">{user.JodiFlat}</td>
                  <td className="text-bold">{user.ExtraFlatSchemeII}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ paddingBottom: '5rem', paddingTop: '1rem' }}></div>
    </div>
  )
}

export default SingleUserunitplan
